<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card class="mb-6" :title="$t('AddDailyReport') | ToUppercase">
                <small>{{ $t("Name") | ToUppercase }}</small><br />
                <vs-input class="w-full" type="text" name="name" v-model="reportName"/>

                <small>{{$t('Date') |ToUppercase}}</small><br>
                <datepicker v-model="reportDate"></datepicker>

                <small>{{$t('Shift') |ToUppercase}}</small><br>
                <vs-select v-model="selectedShift" class="selectExample w-full mb-6">
                    <vs-select-item v-for="(item,index) in shifts" :key="index" :text="item.name" :value="item.id"/>
                </vs-select>

                <small>{{$t('Report') |ToUppercase}}</small><br>
                <quill-editor v-model="content"></quill-editor>

                <br>
                <vs-checkbox v-model="important">{{$t('Important') |ToUppercase}}</vs-checkbox>
                
                <div class="mt-6">
                    <vs-button class="mr-2" @click="addDailyReport">{{ $t("Add") | ToUppercase }}</vs-button>
                    <vs-button @click="$router.go(-1)">{{ $t("Back") | ToUppercase }}</vs-button>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    import { quillEditor } from 'vue-quill-editor'

    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
            Datepicker,
            quillEditor
        },
        data() {
            return {
                reportName: '', 
                selectedShift: 0,
                shifts: [],
                reportDate: new Date(),
                content: ``,
                dailyReports: [],
                important: false,
            };
        },
        methods: {
            updateShifts() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/shift/')
                .then(function (response) {
                    thisIns.shifts = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju izmen",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            addDailyReport() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.post("/report/add?type=daily", {
                    name: thisIns.reportName,
                    date: thisIns.reportDate,
                    shiftID: thisIns.selectedShift,
                    document_content: thisIns.content,
                    important: this.important,
                }).then(function () {
                    thisIns.selectedShift = 0;
                    thisIns.reportDate = null;
                    thisIns.content = ``;
                    thisIns.$vs.notify({
                        text: "Dnevno poročilo shranjeno",
                        color: "success",
                    });
                    thisIns.$router.push('/report/daily');
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri shranjevanju",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
        },
        created() {
            this.updateShifts();
        },
    };
</script>